import type { SerializedSocialChannel } from '../../../types';
import type { ReleasePlanChannels } from '../useReleasePlanChannels';

/**
 * True when a channel can get the posts of an Auto campaign or a release plan: a connected channel,
 * or a saved manual channel. The channel list of the API also answers a "manual" placeholder for
 * each platform that has no saved row; the server does not post on it (`usableRolloutPlatforms`),
 * so the plan must not list it (QA finding B14). The API marks the placeholder with
 * `saved: false`. A saved manual channel with no handle is a real channel (the Composer makes one,
 * and "Remove handle" leaves one), so it stays. An older API sends no `saved`: then the old rule
 * applies, a manual channel needs a handle. Pure.
 */
export function isCampaignChannel(channel: Pick<SerializedSocialChannel, 'status' | 'handle' | 'saved'>): boolean {
  if (channel.saved === false) {
    return false;
  }
  if (channel.status === 'connected') {
    return true;
  }
  if (channel.status !== 'manual') {
    return false;
  }
  if (channel.saved === true) {
    return true;
  }
  return channel.handle !== null && channel.handle.trim() !== '';
}

/** The channels of the Auto campaign tab: the release plan channels with no placeholder. Pure. */
export function campaignPlanChannels(channels: ReleasePlanChannels): ReleasePlanChannels {
  const rows = channels.channels.filter(isCampaignChannel);
  return { ...channels, channels: rows, platforms: rows.map((channel) => channel.platform) };
}
